import { render, staticRenderFns } from "./Renewal.vue?vue&type=template&id=584ce42e"
import script from "./Renewal.vue?vue&type=script&lang=js"
export * from "./Renewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports